import { useEffect, useState } from 'react';

/** True once `isConditionMet` has held without a break for `ms`; false the moment it lapses. */
export function useIsStableFor(isConditionMet: boolean, ms: number): boolean {
    const [isStable, setIsStable] = useState(false);
    useEffect(() => {
        if (!isConditionMet) {
            return undefined;
        }
        const timer = setTimeout(() => setIsStable(true), ms);
        return (): void => {
            clearTimeout(timer);
            setIsStable(false);
        };
    }, [isConditionMet, ms]);
    return isConditionMet && isStable;
}
